export default {

  extend(dest, ...objs) {
    for (const obj in objs) {
      for (const k in objs[obj]) {
        const v = objs[obj][k];
        dest[k] = v;
      }
    }
    return dest;
  },

  windowWidth() {
    return window.innerWidth || this.window.width();
  },

  throttle(func, limit) {
    let inThrottle = false;
    return function () {
      const args = arguments;
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        return setTimeout(
          () => inThrottle = false,
          limit,
        );
      }
    };
  },

  debounce(func, wait, immediate) {
    let timeout = null;
    return function () {
      const context = this;
      const args = arguments;

      const later = function () {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };

      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);

      if (callNow) {
        func.apply(context, args);
      }
    };
  },

  inViewport(el) {
    // special bonus for those using jQuery
    if ((typeof jQuery === 'function') && el instanceof jQuery) {
      el = el[0];
    }

    const rect = el.getBoundingClientRect();

    const bounds = {
      top: rect.top >= 0,
      bottom: rect.bottom <= (window.innerHeight || document.documentElement.clientHeight),
    };

    return bounds.top && bounds.bottom;
  },

  unique(array) {
    const output = {};

    array.forEach((value) => {
      output[value] = value;
    });

    return Object.keys(output);
  },
};
